import { SafeAreaView, StyleSheet, View } from 'react-native';

import { LogoSvg } from '@fhs/ui';

import { AuthHeader } from '../auth-header';

import { AuthContainerProps } from '.';

export function AuthContainerMobile({ children }: AuthContainerProps) {
  return (
    <SafeAreaView style={styles.container}>
      <View style={styles.authHeader}>
        <AuthHeader backgroundHeight={60} imageHeight={150} />
      </View>
      <View style={styles.contentContainer}>
        <LogoSvg style={styles.logo} />
        <View style={styles.content}>{children}</View>
      </View>
    </SafeAreaView>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
  authHeader: {
    position: 'absolute',
    top: 0,
    width: '100%',
  },
  contentContainer: {
    gap: 20,
    alignSelf: 'center',
    alignItems: 'center',
    width: '100%',
    marginVertical: 0,
    paddingHorizontal: 16,
    paddingVertical: 32,
    position: 'relative',
    flex: 1,
  },
  content: {
    flex: 1,
    width: '100%',
  },
  iconButton: {
    position: 'absolute',
    marginHorizontal: 16,
    marginVertical: 12,
  },
  logo: { alignSelf: 'center' },
});
